import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, Grid, Paper, Stack, Typography } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import { DataGrid, GridCsvExportOptions, GridCsvGetRowsToExportParams, GridToolbarContainer, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import { AvatarColor } from '../models/AvatarColor';
import EntitySettings from '../components/EntitySettings';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

export interface IApellidosState {
    data: any[];
    loading: boolean;
}

export default class Notificaciones extends React.Component<{}, IApellidosState> {
    _file: any;
    _fileContent: any[] = [];
    _errors: string[] = [];
    _avatarColors: AvatarColor[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            loading: true
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Layout breadcrumb={
                [
                    {
                        title: 'Inicio',
                        url: '/'
                    },
                    {
                        title: 'Notificaciones',
                        url: ''
                    }
                ]
            }>
                <Box className='stepper'>
                    <Grid container>
                        <Grid item xs={1}>
                            <Typography>
                                <NotificationsNoneIcon className='mainIcon'/>
                            </Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography className='mainTitle'>
                            Notificaciones
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box className='main transparent'>
                    {
                        !this.state.loading && this.state.data.length == 0 && (
                            <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                        )
                    }
                    {
                        !this.state.loading && this.state.data.length > 0 && this.state.data.map((notification: any, index: number) => {
                            return (
                                <Paper elevation={3} square style={{padding: '20px', marginBottom: '20px'}}>
                                    <Stack direction={'row'} spacing={3} justifyContent={'space-between'}>
                                        <Typography variant='h6' fontWeight={300}>
                                            {
                                                Common.GetEntityName(notification.entidadId)
                                            }
                                        </Typography>
                                        <Typography variant='caption'>
                                            {
                                                `${new Date(notification.date).toLocaleDateString()} ${new Date(notification.date).toLocaleTimeString()}`
                                            }
                                        </Typography>
                                    </Stack>
                                    <Typography variant='body2'>
                                        {
                                            notification.message
                                        }
                                    </Typography>
                                </Paper>
                            )
                        })
                    }
                </Box>
            </Layout>
        )
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/notificaciones/all`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    data: response,
                    loading: false
                }
            );
        })
    }
}